module.exports = __webpack_public_path__ + "static/assets/73839060a4f8bdaa0e618100c659ed13.png";